import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/svg/calendar.svg'
import _imports_1 from '../../assets/svg/check-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-68bea960")

_pushScopeId("data-v-68bea960")
const _hoisted_1 = {
  id: "time-range-picker",
  class: "flex flex-row items-center relative w-auto",
  style: {"height":"39px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-row align-middle items-center bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center border-r-0 border-gray-lp-400 border outline-none focus:shadow px-2.5",
  style: {"height":"100%"}
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "calendar"
  })
], -1)
const _hoisted_3 = { class: "flex flex-row w-full bg-white rounded-b-lg overflow-hidden" }
const _hoisted_4 = { class: "w-6 h-6 mx-2" }
const _hoisted_5 = {
  src: _imports_1,
  class: "w-full",
  alt: "check"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 
        `flex flex-row items-center w-full relative ${
          _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        }`
      ,
      style: {"height":"100%"},
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _renderSlot(_ctx.$slots, "trigger", {}, () => [
        _hoisted_2,
        _createVNode("div", {
          class: ["\n            flex align-middle items-center rounded-r-md px-2 text-sm font-light text-center w-full border-gray-lp-400 border\n          ", 
            `${_ctx.disabled ? 'text-gray-lp-600' : 'text-black-lp-300'} ${
              _ctx.isDateAlignCenter
                ? 'flex-col justify-center'
                : 'flex-row justify-between'
            }`
          ],
          style: {"height":"100%"}
        }, _toDisplayString(!_ctx.dates.start
              ? _ctx.$t(_ctx.placeholder)
              : `${_ctx.formatDateWithoutTime(
                  _ctx.dates.start
                )} - ${_ctx.formatDateWithoutTime(_ctx.dates.end)}`), 3)
      ], {}, true)
    ], 2),
    _createVNode(_component_OverlayPanel, {
      ref: "opDatepicker",
      id: "date-picker-content"
    }, {
      default: _withId(() => [
        _createVNode("div", {
          class: 
          `text-center w-full py-3 ${_ctx.advanceStyle.fontSize} ${_ctx.advanceStyle.fontWeight} bg-white text-gray-lp-300 border-b-1 border-gray-lp-400 rounded-t-lg`
        
        }, _toDisplayString(_ctx.$t("Rentang Waktu")), 3),
        _createVNode("div", _hoisted_3, [
          (!_ctx.hideOptions)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: 
            `flex-grow ${_ctx.advanceStyle.fontSize} ${_ctx.advanceStyle.fontWeight} font-normal text-gray-lp-300 border-t border-gray-lp-400`
          
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                  return _withDirectives((_openBlock(), _createBlock("div", {
                    key: index.toString(),
                    class: ["flex flex-row py-2 pr-2 items-center", 
              `${
                _ctx.isOptionDisabled
                  ? 'opacity-50 cursor-default'
                  : 'options cursor-pointer'
              } ${
                _ctx.isSelected(option) && _ctx.highlightOnSelected
                  ? 'bg-gray-lp-1000'
                  : 'bg-white'
              }`
            ],
                    onMousedown: 
              () => (!_ctx.isOptionDisabled ? _ctx.onSelectOptionList(option) : null)
            ,
                    ref: option
                  }, [
                    _createVNode("div", _hoisted_4, [
                      _withDirectives(_createVNode("img", _hoisted_5, null, 512), [
                        [_vShow, _ctx.isSelected(option)]
                      ])
                    ]),
                    _createVNode("div", {
                      class: "capitalize text-left w-full",
                      onClick: ($event: any) => (_ctx.isCloseDateAfterSelect && index ? _ctx.onClickOutside() : null)
                    }, _toDisplayString(_ctx.convertOption(option)), 9, ["onClick"])
                  ], 42, ["onMousedown"])), [
                    [_vShow, 
              (
                _ctx.showOptions ||
                `${_ctx.$t('custom')},${_ctx.$t('hari ini')},${_ctx.$t(
                  '7 hari terakhir'
                )},${_ctx.$t('30 hari terakhir')}`
              ).includes(option)
            ]
                  ])
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: "flex flex-col",
            style: `width: ${_ctx.hideOptions ? '100%' : '360px'}`,
            onMouseenter: _cache[3] || (_cache[3] = (e) => _ctx.onEnterCalendar(true)),
            onMouseleave: _cache[4] || (_cache[4] = (e) => _ctx.onEnterCalendar(false))
          }, [
            _createVNode(_component_DatePicker, {
              ref: "picker",
              modelValue: _ctx.dates,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => (_ctx.dates = $event)),
                _ctx.onDateSelected
              ],
              "is-range": _ctx.isRange,
              class: ["calendar-layout", `${_ctx.customCalendar ? '' : 'calendar'}`],
              attributes: _ctx.attributes,
              "min-date": _ctx.rangeDate.min,
              "max-date": _ctx.rangeDate.max,
              onDayclick: _ctx.dayClick,
              onDayfocusout: _ctx.dayFocusOut,
              "update-on-input": ""
            }, null, 8, ["modelValue", "is-range", "class", "onUpdate:modelValue", "attributes", "min-date", "max-date", "onDayclick", "onDayfocusout"]),
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ], 36)
        ])
      ]),
      _: 3
    }, 512)
  ]))
})